import { Flower2, Gift, Heart, Leaf } from "lucide-react";

const icons = [Flower2, Gift, Heart, Leaf];

function FloatingIcons() {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
      {Array.from({ length: 30 }).map((_, i) => {
        const Icon = icons[i % icons.length];
        const size = Math.random() * 40 + 40; // 40–80px
        const left = Math.random() * 100;
        const delay = Math.random() * 5;
        const duration = Math.random() * 30 + 35; // 20–35 seconds

        return (
          <Icon
            key={i}
            className="absolute text-grey opacity-10 animate-float thin-icon"
            style={{
              width: `${size}px`,
              height: `${size}px`,
              left: `${left}%`,
              top: "100%",
              animationDelay: `${delay}s`,
              animationDuration: `${duration}s`,
              strokeWidth: 0.5, // ← thinner stroke
            }}
          />
        );
      })}
    </div>
  );
}

export default FloatingIcons;
